
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Peter S., 83 ans, décédé le 7 avril 2020</b>
    <br />
    <br />
    <i>Son fils Andreas S. raconte:</i>
    <br />
    <p>
  «La dernière fois que j'ai vu mon père, c'était en janvier, le jour de mon
  anniversaire. Je lui avais rendu visite avec ma femme et mes enfants dans sa
  maison de retraite près de Lugano (TI) où il vivait. Nous ne savions pas que
  c’était notre dernière rencontre. Un an auparavant, il avait souffert d'une
  grave pneumonie. Je m’étais alors immédiatement rendu au Tessin, prévoyant le
  pire. Contre toute attente, il s’en était remis. Puis le virus est arrivé en
  2020. A partir du 10 mars, les EMS tessinois ont été fermés aux visites.
  Quinze jours plus tard, nous ne pouvions plus parler avec lui. Il était trop
  faible, comme beaucoup d’autres résidents de son établissement. Son médecin de
  famille a demandé si nous voulions tester le médicament hydroxychloroquine.
  Nous avons accepté, mais malheureusement cela n'a rien donné. Puis nous nous
  sommes prononcés contre son hospitalisation. Lui ne pouvait alors plus
  s'exprimer, à cause des analgésiques. Mais je suis sûr qu'il aurait pris la
  même décision. Mon père a eu une existence longue et épanouie. Il était prêt à
  partir. Nous étions prêts à l’accepter. Cela nous a permis de lui dire au
  revoir plus facilement. Nous avons compris à ce moment-là que nous faisions
  partie d’une nouvelle communauté, celle des victimes du coronavirus. Cela nous
  a aidés. Le plus difficile a été de ne pas pouvoir l’enterrer. Son urne se
  trouve toujours dans notre salon. Lorsqu'elle a été livrée en avril, ma fille
  de 5 ans a dit: "Grand-père est un peu petit." Maintenant, il vit avec nous
  jusqu'à ce que nous puissions l'enterrer. C'est bien.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;